import React from 'react';
import PropTypes from 'prop-types';

import { isMobileRender } from 'utils/helpers';


function Gif({ msg, isIntersecting, alt }) {
  const { gifUrls, isGif } = msg || {};
  const isMobile = isMobileRender();
  let style = null;

  if (gifUrls?.height && gifUrls?.width) {
    if (isMobile) {
      style = {
        height: `${gifUrls.height / 2}px`,
        width: `${gifUrls.width / 2}px`,
      };
    } else {
      style = {
        height: `${gifUrls.height}px`,
        width: `${gifUrls.width}px`,
      };
    }
  }

  if (isGif) {
    return (
      <div style={style}>
        {isIntersecting && (
          <img
            alt={gifUrls.fixedWidth}
            src={gifUrls.fixedWidth}
            style={style}
          />
        )}
      </div>);
  }

  return alt || null;
}

Gif.propTypes = {
  alt: PropTypes.string.isRequired,
  msg: PropTypes.object.isRequired,
  isIntersecting: PropTypes.bool,
};

Gif.defaultProps = { isIntersecting: false };

export default Gif;

